import { Sentiment } from './types'

export const formatAbsolutePercentage = (value: number) => {
  if (!Number.isFinite(value)) return undefined
  return `${Math.round(Math.abs(value))}%`
}

/** `growthSentiment` says which way is the good news: POSITIVE if a rise is. */
export const resolveSentiment = (value: number, growthSentiment: Sentiment): Sentiment =>
  (Math.sign(value) * growthSentiment) as Sentiment
